import { addEnvironmentWizard } from "./addEnvironment/definition";
import { consentManagerWizard } from "./consentManager/definition";
import { conversionEventsWizard } from "./conversionEvents/definition";
import { enableDestinationWizard } from "./enableDestination/definition";
import { AnyWizardDefinition } from "./framework/types";
import { installSdkWizard } from "./installSdk/definition";

// Every wizard registered here can be summoned with
// `useWizards().openWizard(type, params)` and gets a command bar entry.
export const wizardDefinitions: AnyWizardDefinition[] = [
  enableDestinationWizard,
  installSdkWizard,
  conversionEventsWizard,
  consentManagerWizard,
  addEnvironmentWizard,
];
